import React, { useState, useEffect } from 'react';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Scroll to top handler
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 w-12 h-12 bg-gradient-to-br from-primary-500 to-accent-500 text-white rounded-full shadow-premium-lg hover:shadow-premium-xl transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 flex items-center justify-center group"
          aria-label="Back to top"
        >
          <i className="fas fa-chevron-up text-lg group-hover:animate-bounce"></i>
        </button>
      )}
    </>
  );
};

export default BackToTop; 